/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const SET_INFOCARD_CALLER_SCREEN = 'SET_INFOCARD_CALLER_SCREEN';
export const SET_INFOCARD_HIGHLIGHT = 'SET_INFOCARD_HIGHLIGHT';
export const SET_INFOCARD_GHOST_MODE = 'SET_INFOCARD_GHOST_MODE';
export const SET_INFOCARD_TIMER_ID = 'SET_INFOCARD_TIMER_ID';
export const SET_INFOCARD_NAVIGATION_HIGHLIGHT = 'SET_INFOCARD_NAVIGATION_HIGHLIGHT';
